import { render, staticRenderFns } from "./ProductList2.vue?vue&type=template&id=2e2ed048&scoped=true&"
import script from "./ProductList2.vue?vue&type=script&lang=js&"
export * from "./ProductList2.vue?vue&type=script&lang=js&"
import style0 from "./ProductList2.vue?vue&type=style&index=0&id=2e2ed048&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ed048",
  null
  
)

export default component.exports